
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.448 1.724c-.458 0-.895.183-1.21.501l-.007.008a1.703 1.703 0 00-.507 1.215v18.104c0 .457.18.893.507 1.215l.008.008c.314.318.751.5 1.21.5H8.62a.862.862 0 110 1.725H3.448c-.91 0-1.79-.36-2.433-1.01A3.427 3.427 0 010 21.552V3.448c0-.912.36-1.79 1.015-2.438A3.425 3.425 0 013.448 0h5.173a.862.862 0 110 1.724H3.448zM17.063 5.425a.862.862 0 011.219 0l6.465 6.465a.862.862 0 010 1.22l-6.465 6.465a.862.862 0 11-1.22-1.219L22.92 12.5l-5.856-5.856a.862.862 0 010-1.22z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.759 12.5c0-.476.386-.862.862-.862h15.517a.862.862 0 010 1.724H8.621a.862.862 0 01-.862-.862z","fill":"#fff"}})])
          )
        }
      }
    